const peerScoreSet = {
    'Choose your role': [0,0,0,0,0,0],
    'CFO': [50,50,100,100,25,100],
    'CAO or Controller': [25,100,20,50,100,25],
    'VP or Director of Finance': [50,50,75,75,25,25],
    'VP or Director of FP&A': [25,25,50,75,75,100],
    'VP or Director Corp. Strategy and Development': [50,25,25,50,75,100],
    'Head of Procurement': [25,50,75,100,75,25],
    'VP or Director of Financial Systems': [50,25,100,25,50,25],
    'Chief Audit Executive': [100,50,25,25,50,75],
};

export default peerScoreSet;